import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre1/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre2/", true, /\.webp/)); }
const Aurora = () => { return ImportHelper.importAll(require.context("../assets/images/Aurora/", true, /\.webp/)); }
const Actio = () => { return ImportHelper.importAll(require.context("../assets/images/Actio/", true, /\.webp/)); }
const Cancha = () => { return ImportHelper.importAll(require.context("../assets/images/Cancha/", true, /\.webp/)); }
const Carril = () => { return ImportHelper.importAll(require.context("../assets/images/Carril/", true, /\.webp/)); }
const Asoleacion = () => { return ImportHelper.importAll(require.context("../assets/images/Asoleacion/", true, /\.webp/)); }
const Jacuzzi = () => { return ImportHelper.importAll(require.context("../assets/images/Jacuzzi/", true, /\.webp/)); }
const WiFi = () => { return ImportHelper.importAll(require.context("../assets/images/WiFi/", true, /\.webp/)); }
const Eventos = () => { return ImportHelper.importAll(require.context("../assets/images/Eventos/", true, /\.webp/)); }
const Crossfit = () => { return ImportHelper.importAll(require.context("../assets/images/Crossfit/", true, /\.webp/)); }
const Gimnasio = () => { return ImportHelper.importAll(require.context("../assets/images/Gimnasio/", true, /\.webp/)); }
const Yoga = () => { return ImportHelper.importAll(require.context("../assets/images/Yoga/", true, /\.webp/)); }
const Lectura = () => { return ImportHelper.importAll(require.context("../assets/images/Lectura/", true, /\.webp/)); }
const Estadia = () => { return ImportHelper.importAll(require.context("../assets/images/Estadia/", true, /\.webp/)); }
const Masajes = () => { return ImportHelper.importAll(require.context("../assets/images/Masajes/", true, /\.webp/)); }
const PingPong = () => { return ImportHelper.importAll(require.context("../assets/images/PingPong/", true, /\.webp/)); }
const BBQ = () => { return ImportHelper.importAll(require.context("../assets/images/BBQ/", true, /\.webp/)); }
const Piscina = () => { return ImportHelper.importAll(require.context("../assets/images/Piscina/", true, /\.webp/)); }
const Parque = () => { return ImportHelper.importAll(require.context("../assets/images/Parque/", true, /\.webp/)); }
const Habilidades = () => { return ImportHelper.importAll(require.context("../assets/images/Habilidades/", true, /\.webp/)); }
const Guarderia = () => { return ImportHelper.importAll(require.context("../assets/images/Guarderia/", true, /\.webp/)); }
const Pet = () => { return ImportHelper.importAll(require.context("../assets/images/Pet/", true, /\.webp/)); }

const Piso3 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 3/ALTA/", true, /\.jpg/)); }
const Piso4 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 4/ALTA/", true, /\.jpg/)); }
const Piso5 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 5/ALTA/", true, /\.jpg/)); }
const Piso6 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 6/ALTA/", true, /\.jpg/)); }
const Piso7 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 7/ALTA/", true, /\.jpg/)); }
const Piso8 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 8/ALTA/", true, /\.jpg/)); }
const Piso9 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 9/ALTA/", true, /\.jpg/)); }
const Piso10 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 10/ALTA/", true, /\.jpg/)); }
const Piso11 = () => { return ImportHelper.importAll(require.context("../assets/images/Vista piso 11/ALTA/", true, /\.jpg/)); }

export const ContextLoader = {
    "General View": GeneralView,
    "Torre 1": Torre1,
    "Torre 2": Torre2,
    "Terraza Aurora (Piso 31)": Aurora,
    "Salón Actio": Actio,
    "Cancha Multifuncional": Cancha,
    "Zona Acúatica - Carril de Nado": Carril,
    "Zona de Asoleación": Asoleacion,
    "Asoleación - Jacuzzi Seco": Jacuzzi,
    "Terraza WiFi": WiFi,
    "Salón de Eventos": Eventos,
    "Zona Crossfit al Aire Libre": Crossfit,
    "Centro de Actividad Física": Gimnasio,
    "Deck de Yoga": Yoga,
    "Zona de Lectura al Aire Libre": Lectura,
    "Zona de Estadía Aire Libre": Estadia,
    "Zona de Masajes": Masajes,
    "Zona de Ping Pong": PingPong,
    "Zona BBQ": BBQ,
    "Piscina para Niños con Estadero": Piscina,
    "Parque Infantil": Parque,
    "Habilidades Múltiples Infantiles": Habilidades,
    "Guardería": Guarderia,
    "Zona Pet Friendly": Pet,
    "Piso 3": Piso3,
    "Piso 4": Piso4,
    "Piso 5": Piso5,
    "Piso 6": Piso6,
    "Piso 7": Piso7,
    "Piso 8": Piso8,
    "Piso 9": Piso9,
    "Piso 10": Piso10,
    "Piso 11": Piso11,
}
